import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';

import { default as PeriodPicker } from './ResourcePeriodPicker'

import { StartEnd, DisabledProps } from './PeriodPicker'

import { FocusedInputShape, OrientationShape } from 'react-dates';

export type PickerProps = StartEnd & {
  advert_id: number,
  prefix?: string,
  onDatesChange: (arg: { startDate: Moment | null, endDate: Moment | null }) => void
  onFocusChange: (fi: FocusedInputShape) => void
  focusedInput: FocusedInputShape
  showClearDate?: boolean
  orientation?: OrientationShape
  numberOfMonths?: number
  close: () => void
}

export default class AdvertPeriodPicker extends React.Component<PickerProps> {

  constructor(props, context) {
    super(props, context)
  }

  render() {
    return (
      <PeriodPicker
        {...this.props}
        data_url={`/rentals/${this.props.advert_id}/datepicker_data`}
        disabled={!this.props.advert_id}
      />
    )
  }
}